import axios from '@api/customAxios'
import BasicApiClass from '../classes/BasicApiClass'

export const reporteAxaApi  = new BasicApiClass({
    recurso: 'reporteAxa',
    recursoMulti: 'reportesAxa'
})

